// 1. IMPORTS
import React, { useEffect, useState } from "react";
import { Card, Col, Form, notification, Row } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import BasicButtonPrimary from "components/BasicButtonPrimary";
import PaymentMethodServiceAPI from "services/PaymentMethodServiceAPI";

// 2. COMPONENT & STATES
function PaymentMethodConfigPanel({ paymentMethodType, paymentTypeName, onBack, prepareValues, includeQrCode = true, children }) {
  const [form] = Form.useForm();
  const [paymentMethodId, setPaymentMethodId] = useState(null);
  const [loading, setLoading] = useState(false);

  // 4. API CALLS & EVENT HANDLERS
  const handleBack = () => {
    form.resetFields();
    onBack();
  };

  const getPaymentMethod = async () => {
    setLoading(true);
    try {
      const data = await PaymentMethodServiceAPI.getListPaymentMethod({
        skip: 0,
        limit: 1,
        filter: { paymentMethodType },
      });
      const record = data?.data?.[0] || {};
      setPaymentMethodId(record.paymentMethodId || null);
      form.setFieldsValue({
        paymentMethodName: record.paymentMethodName || undefined,
        paymentMethodReceiverName: record.paymentMethodReceiverName || undefined,
        paymentMethodIdentityNumber: record.paymentMethodIdentityNumber || undefined,
        paymentMethodReferName: record.paymentMethodReferName || undefined,
        paymentMethodCode: record.paymentMethodCode || undefined,
        paymentMethodQrCodeUrl: record.paymentMethodQrCodeUrl
          ? [{ uid: "saved-qr", name: "QR Code", status: "done", url: record.paymentMethodQrCodeUrl }]
          : [],
      });
    } catch (error) {
      notification.error({
        message: "",
        description: "Không lấy được thông tin vui lòng thử lại",
      });
      handleBack();
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    if (loading) return;
    setLoading(true);
    const preparedValues = prepareValues ? prepareValues(values) : values;
    const data = {
      ...preparedValues,
      paymentMethodType,
    };
    if (includeQrCode) {
      data.paymentMethodQrCodeUrl = values.paymentMethodQrCodeUrl?.[0]?.url || null;
    }
    try {
      if (paymentMethodId) {
        await PaymentMethodServiceAPI.updatePaymentMethod({ id: paymentMethodId, data });
      } else {
        await PaymentMethodServiceAPI.createPaymentMethod(data);
      }
      notification.success({ message: "", description: "Thành công" });
      await getPaymentMethod();
    } catch (error) {
      notification.error({ message: "", description: "Thất bại" });
    } finally {
      setLoading(false);
    }
  };

  // 5. SIDE EFFECTS
  useEffect(() => {
    getPaymentMethod();
    // Each method mounts a separate panel; its type does not change while mounted.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 8. MAIN JSX
  return (
    <div>
      <BasicButtonPrimary type="default" icon={<LeftOutlined />} onClick={handleBack} />
      <Card className="my-3">
        <h5>{`Cài đặt ${paymentTypeName || ""}`}</h5>
        <Row>
          <Col xs={24} sm={24} md={19} lg={12}>
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
              {children}
              <BasicButtonPrimary
                htmlType="submit"
                loading={loading}
                disabled={loading}
                text={paymentMethodId ? "Cập nhật" : "Thêm mới"}
              />
            </Form>
          </Col>
        </Row>
      </Card>
    </div>
  );
}

// 9. EXPORTS
export default PaymentMethodConfigPanel;